import React from "react";
import { Heart } from "lucide-react";
import useFavorites from "@/hooks/useFavorites";
import { useT } from "@/lib/config/useTranslations";
import { useLanguage } from "@/lib/config/useLanguage";

export default function BtnFavorites({ className = "" }) {
    const { count, isHydrated } = useFavorites();
    const { translations } = useT();
    const { localizePath } = useLanguage();
    const label = translations?.common?.favorites ?? 'Избранное';
    const displayCount = isHydrated ? count : 0;
    const hasFavorites = displayCount > 0;

    return (
        <a
            href={localizePath('/favorites')}
            aria-label={label}
            className={`rounded-xl flex flex-row items-center gap-2 bg-white px-3.5 py-2.5 text-sm font-semibold text-gray-900 shadow-xs hover:bg-gray-100 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-white ${className}`}
        >
            <div className="relative inline-flex">
                <Heart
                    className={`h-5 w-5 ${hasFavorites ? 'text-red-500' : 'text-default-500'}`}
                    fill={hasFavorites ? 'currentColor' : 'none'}
                />
                {hasFavorites && (
                    <span
                        className="absolute -top-2 -right-2 flex size-4 items-center justify-center rounded-full bg-red-500 text-[10px] font-semibold text-white ring-2 ring-white"
                    >
                        {displayCount}
                    </span>
                )}
            </div>
            <span className={'text-small hidden xl:inline'}>{label}</span>
        </a>
    );
}
